const productBulkOption = document.querySelector(".bulk-option");
const productQuantity = document.querySelector(".quantity__input");
const productPrice = document.querySelector(".product-price");
const productComparedPrice = document.querySelector(".product-compared-price");
const productPriceText = document.querySelector(".price-item--sale");

productBulkOption.addEventListener("change", function() {
  var productBulkOptionValue = this.value;
  productQuantity.value = productBulkOptionValue;
  // var productPriceValue = productPrice.value.trim().substring(1);
  // var productComparedPriceValue = productComparedPrice.value.trim().substring(1);
  // var productPriceNewValue = productPriceValue * productBulkOptionValue;
  // var productComparedPriceNewValue = productComparedPriceValue * productBulkOptionValue;
  // productPriceText.innerHTML = `$${productPriceNewValue} AUD`;
});